import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { baseUrl } from "../api/axiosConfig";
import axios from "axios";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    action: "login",
    email: "",
    password: "",
  });

  const [isChecked, setIsChecked] = useState(false);
  const isAuthenticated = localStorage.getItem("token"); // Check authentication status
 
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


  useEffect(() => {
    if (isAuthenticated) {
        navigate('/dashboard');
    }
}, [isAuthenticated, navigate]);


  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    const savedPassword = localStorage.getItem("password");

    if (savedEmail && savedPassword) {
      // Perform login logic with saved credentials
      setFormData({
        action: "login",
        email: savedEmail,
        password: savedPassword,
      });
    }
  }, []);

  const [errors, setErrors] = useState({});
  const [showError, setShowError] = useState(false);
  const handleCloseError = () => setShowError(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.email) formErrors.email = "Email is required";
    if (!formData.password) formErrors.password = "Password is required";
    return formErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formErrors = validateForm();
      if (Object.keys(formErrors).length === 0) {
        const response = await axios.post(`${baseUrl}/auth`, formData);
        const token = response.data.token;
        if(token){
          
        localStorage.setItem("token", token);
        localStorage.setItem("user", formData.email);
        if (isChecked) {
          localStorage.setItem("email", formData.email);
          localStorage.setItem("password", formData.password);
        }
        navigate("/dashboard");
        setLoading(true);
       }
      } else {
        setErrors(formErrors);
        setLoading(false);
      }
    } catch (error) {
      setErrors(error.response.data);
      setShowError(true);
      setLoading(false);
    }
  };

  return (
    <Container fluid className="d-flex align-items-center min-vh-100 bg-light">
      <Row className="w-100">
        {/* Left Section */}
        <Col md={6} className="d-flex flex-column justify-content-center px-5">
          <div>
            {/* Logo */}
            <div className="d-flex align-items-center mb-4">
              <img
                src="coforge-logo.png"
                alt="Coforge"
                height="40"
                className="me-2"
              />
              <img src="aurenity-logo.png" alt="Aurenity" />
            </div>

            {/* Title */}
            <h4 className="mb-3">Loss Runs Extraction</h4>
            <p className="text-muted mb-4">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>

            {/* Login Form */}
            <h5>Log In to your Account</h5>
            {/* {errors && errors.message} */}
            {showError && (
              <Alert variant="danger" onClose={handleCloseError} dismissible>
                <Alert.Heading>Error!</Alert.Heading>
                <p>{errors.message}</p>
              </Alert>
            )}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                  isInvalid={!!errors.email}
                  className="py-2"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  isInvalid={!!errors.password}
                  className="py-2"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                className="mb-3 d-flex align-items-center"
                controlId="formCheckbox"
              >
                <Form.Check
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  name="rememberMe"
                  label="Remember me"
                  className="me-auto"
                />
                {/* <Link to="/forgot-password" className="text-decoration-none text-muted">
                  Forgot password?
                </Link> */}
              </Form.Group>

              {loading && <div className="text-center"><Spinner animation="border" role="status"><span className="sr-only">Loading...</span></Spinner></div>}
              <Button
                type="submit"
                variant="primary"
                className="w-100 py-2"
                style={{ backgroundColor: "#D63384", border: "none" }}
              >
                {loading ? 'Logging in...' : 'Member Login'}
                
              </Button>
            </Form>
            {/* <p className="mt-3 text-center">
              Don't have an account? <Link to="/register" className="text-decoration-none" style={{ color: '#D63384' }}>Sign up</Link>
            </p> */}
          </div>
        </Col>

        {/* Right Section */}
        <Col md={6} className="d-none d-md-block">
          <div
            style={{
              backgroundImage: `url('img-1.png')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100vh",
            }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
